/* ChewNectar box builder. Quantity-tier pricing, shared by the homepage builder
   and the product page stack-and-save module. */
(() => {
  const money = (c) => (window.cnMoney ? window.cnMoney(c) : String(c));

  const build = (root) => {
    const tiers = JSON.parse(root.dataset.tiers || '[]').sort((a, b) => a.qty - b.qty);
    const maxQty = tiers.length ? tiers[tiers.length - 1].qty : 4;
    const unit = root.dataset.unit || 'jar';
    const picks = new Map();

    const slots = root.querySelector('[data-cb-slots]');
    const bar = root.querySelector('[data-cb-bar]');
    const subEl = root.querySelector('[data-cb-sub]');
    const saveRow = root.querySelector('[data-cb-saverow]');
    const saveEl = root.querySelector('[data-cb-save]');
    const wasEl = root.querySelector('[data-cb-was]');
    const totEl = root.querySelector('[data-cb-total]');
    const nextEl = root.querySelector('[data-cb-next]');
    const addBtn = root.querySelector('[data-cb-add]');

    const count = () => [...picks.values()].reduce((n, p) => n + p.qty, 0);
    const subtotal = () => [...picks.values()].reduce((n, p) => n + p.qty * p.price, 0);

    const tierFor = (n) => { let hit = null; tiers.forEach((t) => { if (n >= t.qty) hit = t; }); return hit; };
    const nextTier = (n) => tiers.find((t) => t.qty > n) || null;
    const priceWith = (t, sub) => {
      if (!t) return sub;
      if (t.mode === 'flat') return Math.round(t.value * 100);
      return Math.round((sub * (100 - t.value)) / 100);
    };

    const render = () => {
      const n = count();
      const sub = subtotal();
      const t = tierFor(n);
      const total = priceWith(t, sub);
      const saved = Math.max(0, sub - total);

      root.querySelectorAll('[data-tier-q]').forEach((el) => {
        const q = Number(el.dataset.tierQ);
        el.classList.toggle('is-on', !!t && t.qty === q);
        el.classList.toggle('is-done', n >= q);
      });

      if (slots) {
        const flat = [];
        picks.forEach((p) => { for (let i = 0; i < p.qty; i += 1) flat.push(p); });
        [...slots.children].forEach((li, i) => {
          const p = flat[i];
          li.classList.toggle('is-full', !!p);
          li.style.setProperty('--sc', p ? p.color : '');
          li.style.setProperty('--sc2', p ? p.color2 : '');
          li.innerHTML = p && p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : (li.dataset.label || '');
        });
      }
      if (bar) bar.style.width = Math.min(100, (n / maxQty) * 100) + '%';
      if (subEl) subEl.textContent = money(sub);
      if (totEl) totEl.textContent = money(total);
      if (wasEl) wasEl.textContent = saved > 0 ? money(sub) : '';
      if (saveRow) saveRow.hidden = saved <= 0;
      if (saveEl) saveEl.textContent = money(saved);

      if (nextEl) {
        const nx = nextTier(n);
        if (!n) {
          nextEl.textContent = nextEl.dataset.empty || '';
        } else if (nx) {
          const need = nx.qty - n;
          const deal = nx.mode === 'flat' ? money(nx.value * 100) + ' for all ' + nx.qty : nx.value + '% off';
          nextEl.textContent = 'Add ' + need + ' more ' + unit + (need > 1 ? 's' : '') + ' for ' + deal + '.';
        } else {
          nextEl.textContent = nextEl.dataset.best || 'Best price unlocked.';
        }
        nextEl.hidden = !nextEl.textContent;
      }
      if (addBtn) addBtn.disabled = n === 0;
      root.querySelectorAll('[data-cb-plus]').forEach((b) => { b.disabled = n >= maxQty; });
    };

    const change = (btn, delta) => {
      const id = btn.dataset.id;
      const cur = picks.get(id);
      const n = count();
      if (delta > 0 && n >= maxQty) return;
      if (!cur && delta > 0) {
        picks.set(id, {
          qty: 1,
          price: Number(btn.dataset.price),
          title: btn.dataset.title,
          img: btn.dataset.img,
          color: btn.dataset.color,
          color2: btn.dataset.color2
        });
      } else if (cur) {
        cur.qty += delta;
        if (cur.qty <= 0) picks.delete(id);
      }
      const out = root.querySelector('[data-cb-out="' + id + '"]');
      if (out) out.textContent = picks.has(id) ? picks.get(id).qty : 0;
      const card = btn.closest('[data-cb-card]');
      if (card) card.classList.toggle('is-in', picks.has(id));
      render();
    };

    root.querySelectorAll('[data-cb-plus]').forEach((b) => b.addEventListener('click', () => change(b, 1)));
    root.querySelectorAll('[data-cb-minus]').forEach((b) => b.addEventListener('click', () => change(b, -1)));

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const items = [...picks.entries()].map(([id, p]) => ({ id: Number(id), quantity: p.qty }));
        if (!items.length) return;
        addBtn.setAttribute('aria-busy', 'true');
        await window.cnAddToCart(items);
        addBtn.removeAttribute('aria-busy');
      });
    }
    render();
  };

  const start = () => document.querySelectorAll('[data-cb]').forEach((el) => {
    if (el.dataset.cbReady) return;
    el.dataset.cbReady = '1';
    build(el);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
